<template>
  <div class="page-container">
    <h1>後台編輯頁（AI 優化 + 原文切換）</h1>
    <!-- TinyMCE 編輯器 (手動編輯內容) -->
    <div class="editor-section">
      <Editor
        v-model="content"
        :init="editorInitOptions"
      />
    </div>


    <div class="current-status">
      <span>當前動作：</span>
      <span v-if="editMessageType === 1">補充GPT內容</span>
      <span v-else-if="editMessageType === 2">手動編輯「原文」</span>
      <span v-else-if="editMessageType === 3">手動編輯「AI文」</span>

      &nbsp;|&nbsp;

      <span>當前顯示：</span>
      <span v-if="showAiContent">AI文內容</span>
      <span v-else>原文內容</span>
    </div>

    <!-- 操作按鈕區 -->
    <div class="actions">

      <!--當前動作 補充內容? 顯示原文? 顯示AI內容?-->

     <!-- 下拉：選擇「編輯動作」: 1=補充GPT, 2=原文, 3=AI文章 -->
     <label>
        <span>操作模式：</span>
        <select class="my-select" v-model="editMessageType">
          <option :value="1">補充GPT內容</option>
          <option :value="2">手動編輯「原文」</option>
          <option :value="3">手動編輯「AI文」</option>
        </select>
      </label>

      <label>
        <input type="checkbox" v-model="includeOriginal" />
        AI帶入原文
      </label>
      <label>
      <input type="checkbox" v-model="includeStyle" :disabled="edittype != 'product'" />
        AI帶入樣式
      </label>

       <!-- 下拉：選擇「GPT 模型」: gpt-3.5 or gpt-4 -->
       <label>
        <span>GPT模型：</span>
        <select class="my-select" v-model="selectedModel">
          <option value="gpt-3.5-turbo">GPT-3.5 Turbo</option>
          <option value="gpt-4">GPT-4</option>
        </select>
      </label>

      <button 
            class="my-btn my-btn-secondary"
            :disabled="isLoading || editMessageType !== 1"
            @click="onFetchAi"
          >
            {{ isLoading ? '請求中請稍後..' : 'AI 優化 (GPT)' }}
          </button>

      <!-- 顯示 (原文/AI) 切換 -->
      <label>
        <span>檢視模式：</span>
        <select 
          class="my-select my-select-orange" 
          v-model="viewMode"
        >
          <option :value="false">顯示原文</option>
          <option :value="true">顯示AI文</option>

        </select>
      </label>

      <!-- 儲存 -->
      <button class="my-btn" @click="saveHtml"><span v-if="showAiContent">儲存AI文</span><span v-else>儲存原文</span>
      </button>
    </div>

    <!-- 原文 / AI內容 切換呈現處 -->
    <div class="preview-area">
      <h2>預覽</h2>
      <!-- 如果 showAiContent = true → 顯示 AIHtml
      否則 顯示 myhtml (後端原生 / 手動編輯後的內容) -->
      <div class="detail-html" v-html="showAiContent ? aiHtml : myhtml"></div>
    </div>
  </div>
</template>

<script setup>
import {getCurrentInstance , ref, onMounted, watch } from 'vue'
import Editor from '@tinymce/tinymce-vue'
import 'tinymce/tinymce'
import 'tinymce/themes/silver'
import 'tinymce/icons/default'
import 'tinymce/models/dom'
import 'tinymce/plugins/lists'
import 'tinymce/plugins/link'
import 'tinymce/plugins/image'
import 'tinymce/plugins/code'
import { useRoute } from 'vue-router'
import axios from 'axios'
import Swal from 'sweetalert2'
// ----------------------
// 路由 & 參數
// ----------------------
const route = useRoute()
const edittype = route.query.edittype
const product_id = route.query.product_id ? route.query.product_id : undefined
const htmlname = route.query.htmlname ? route.query.htmlname : undefined
const vpage = route.query.vpage ? route.query.vpage : undefined

// ----------------------
// TinyMCE
// ----------------------
const content = ref('')
const myhtml = ref('')

// ----------------------
// AI 相關
// ----------------------
// 是否 loading 中
const isLoading = ref(false)
const editMessageType = ref(2) // 1=補充GPT, 2=原文, 3=AI文章
const selectedModel = ref('gpt-3.5-turbo')  // 預設用3.5 Turbo
const aiHtml = ref('')         // 存放 GPT 回傳的 HTML
const includeOriginal = ref(true) // 是否帶入原文
const includeStyle = ref(true) //是否帶入樣式
const showAiContent = ref(false) // 用於顯示AI/原文
const viewMode = ref(false)     // 預設 false => "顯示原文"

// ----------------------
// 手動 / AI 模式 + 切換
// ----------------------
const isManualMode = ref(false)

// ----------------------
const instance = getCurrentInstance()
const coName   = instance.appContext.config.globalProperties.$COMPANY_NAME
const coNameEn = instance.appContext.config.globalProperties.$COMPANY_NAMEn


const editorInitOptions = {
  license_key: 'gpl',
  skin_url: '/tinymce/skins/ui/oxide',
  content_css: '/tinymce/skins/content/default/content.css',
  height: 600,
  language: 'zh_CN',
  plugins: 'lists link image code',
  toolbar: 'undo redo | bold italic | code',

  valid_elements: '*[*]',
  invalid_elements: '',
  extended_valid_elements:
    'style[type|scoped],' +
    'script[src|type],' +
    'iframe[src|width|height|allowfullscreen|frameborder],' +
    'img[*],' +
    'link[href|rel],' +
    'video[*],' +
    'audio[*]',
  valid_children: '+body[style],+div[style],+p[style],+div[script],+body[script]',
  forced_root_block: '',
  force_br_newlines: false,
  force_p_newlines: false,
  verify_html: false,
}



// ----------------------
// 1. 載入後端 HTML
// ----------------------
onMounted(async () => {
  try {

    switch(edittype){
      case 'product':
        includeStyle.value = true
        break
      case 'htmlpage':
        includeStyle.value = false
        break
      default:
        includeStyle.value = true
        break
    }

    console.log('includeStyle:', includeStyle.value)
    const res = await axios.get('/api/admin/loadhtml', {
      params: { edittype , product_id, htmlname }
    })
    console.log('res:', res)
    if (res.data.success && res.data.html) {
      myhtml.value = res.data.html
      //console.log('載入成功:', res.data.html)
      content.value = res.data.html  // ← 讓編輯器也同步
      if(editMessageType.value != 1){
        isManualMode.value = true
      }

    } else {
      //console.warn('載入失敗:', res.data.message)
    }
  } catch (err) {
    console.error('載入錯誤:', err)
  }
})

// 監聽手動模式下, 若 content 改變, 也同步 myhtml
watch(content, (newVal) => {
  // 這裡邏輯：若 isManualMode.value === true，就同步到 myhtml 或 aiHtml
  if (isManualMode.value) {
    if (editMessageType.value === 2) {
      myhtml.value = newVal
    } else if (editMessageType.value === 3) {
      aiHtml.value = newVal
    }
  }
}) 

// ----------------------
// 2. 切換手動編輯
// ----------------------
watch(editMessageType, (newVal) => {
  switch (newVal) {
    case 1:
      isManualMode.value = false
      content.value = `
      我想製作一個商品詳細說明：<br>
      主要圖片:...<br>
      產品特色:...<br>
      產品影片:...<br>
      產品圖片:...<br>
      這是一個段落<br>
      ` // 清空
      break
    case 2:
      isManualMode.value = true
      content.value = myhtml.value
      break
    case 3:
      isManualMode.value = true
      content.value = aiHtml.value
      break
  }
})


const gpt_style = ref(`
       .my-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 16px;
        }
        .my-row {
          display: flex;
          flex-wrap: wrap;
          gap: 16px;
        }
        .my-col-1 {
          flex: 0 0 8.333%;
        }
        .my-col-2 {
          flex: 0 0 16.666%;
        }
        .my-col-3 {
          flex: 0 0 25%;
        }
        .my-col-4 {
          flex: 0 0 33.333%;
        }
        .my-col-5 {
          flex: 0 0 41.666%;
        }
        .my-col-6 {
          flex: 0 0 50%;
        }
        .my-col-7 {
          flex: 0 0 58.333%;
        }
        .my-col-8 {
          flex: 0 0 66.666%;
        }
        .my-col-9 {
          flex: 0 0 75%;
        }
        .my-col-10 {
          flex: 0 0 83.333%;
        }
        .my-col-11 {
          flex: 0 0 91.666%;
        }
        .my-col-12 {
          flex: 0 0 100%;
        }
        @media (max-width: 768px) {
          .my-col-6 {
            flex: 0 0 100%;
          }
          .my-col-4 {
            flex: 0 0 50%;
          }
        }
        .my-heading {
          font-size: 1.5rem;
          margin-bottom: 0.75rem;
          font-weight: bold;
        }
        .my-text-body {
          font-size: 1rem;
          line-height: 1.6;
          color: #333;
          margin-bottom: 1rem;
        }
        .my-text-muted {
          color: #999;
          font-size: 0.9rem;
        }
        .my-text-center {
          text-align: center;
        }
        .my-text-right {
          text-align: right;
        }
        .my-text-left {
          text-align: left;
        }
        .my-img-fluid {
          max-width: 100%;
          height: auto;
          display: block; 
        }
        .my-mb-1 {
          margin-bottom: 0.25rem !important;
        }
        .my-mb-2 {
          margin-bottom: 0.5rem !important;
        }
        .my-mb-3 {
          margin-bottom: 1rem !important;
        }
        .my-mb-4 {
          margin-bottom: 1.5rem !important;
        }

        .my-mt-1 {
          margin-top: 0.25rem !important;
        }
        .my-mt-2 {
          margin-top: 0.5rem !important;
        }
        .my-mt-3 {
          margin-top: 1rem !important;
        }
        .my-mt-4 {
          margin-top: 1.5rem !important;
        }
        .my-card {
          background: #fff;
          border: 1px solid #ddd;
          border-radius: 6px;
          padding: 16px;
          box-shadow: 0 2px 4px rgba(0,0,0,0.1);
          margin-bottom: 1rem;
        }
        .my-card-header {
          font-size: 1.2rem;
          font-weight: bold;
          margin-bottom: 0.5rem;
        }
        .my-card-body {
        }
        .my-card-footer {
          margin-top: 1rem;
          border-top: 1px solid #eee;
          padding-top: 0.5rem;
          text-align: right;
        }
`)


async function onFetchAi() {
  if(isLoading.value){
    return
  }
  if(content.value.trim().length === 0){
   Swal.fire({
      icon: 'error',
      title: '請輸入內容',
      text: '請輸入內容後再點擊「AI 優化」'
    })
    return
  }
  isLoading.value = true
  try {
    await fetchAiHtml()
  } catch (err) {
    console.error(err)
  } finally {
    isLoading.value = false
  }
}

// ----------------------
// 3. 呼叫 GPT API 取得 AI 優化 HTML
// ----------------------
async function fetchAiHtml() {
  try {

    // 1. 你定義的自訂CSS class描述 (可縮短或詳細)
    //    要盡量精簡, 避免 tokens 過多, 影響費用/性能
    let userPrompt = "";
    if(includeOriginal.value){
      userPrompt += `以下為原文
        ${myhtml.value}
      `;
    }
    userPrompt += `請在 <img> 或 <iframe> 中加 loading="lazy", 幫助效能\n補充2.請加上 title="${coName} (${coNameEn})"、alt="${coName} (${coNameEn})"，提升 SEO`;
    if(includeStyle.value){
      userPrompt += `\n可參考樣式${gpt_style.value}`;
    }
    if (editMessageType.value === 1 && content.value) {
      // 用「newContent」裝去標籤後的純文字
      const newContent = content.value.replace(/<[^>]*>/g, '');
      userPrompt += `\n補充內容: ${newContent}`;
    }
    console.log('userPrompt:', userPrompt);
    // 3. 設定 GPT API 參數
    const payload = {
      model: selectedModel.value,  // 這裡改成由下拉 selectedModel 選擇
      messages: [
        { role: 'system', content: '你是一個前端排版設計AI，不需要 <head> 或 <style> 或 <button>，請你直接產出完整 HTML + CSS，不使用 Bootstrap / Tailwind / 其他框架。請確保回覆字數足夠，不要提早結束。必須是完整的原始碼' },
        { role: 'user', content: userPrompt }
      ],
      temperature: 0.7
    };

    // 4. 發送請求給 OpenAI
    const response = await axios.post(
      'https://api.openai.com/v1/chat/completions', 
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${process.env.VUE_APP_OPENAI_KEY}`,
          "OpenAI-Organization": `${process.env.VUE_APP_OPENAI_ORGANIZATION_ID}`,
          temperature: 0.7,
          max_tokens: 4096
        }
      }
    );

    // 5. 取得 GPT 回傳
    const gptReply = response.data.choices?.[0]?.message?.content || '';
    console.log('GPT 回傳:', gptReply);

    // 6. 更新 aiHtml, 切到 AI 模式
    aiHtml.value = gptReply;

    // 切回 Editor => AI 模式: 高度=400, 顯示 AI
    isManualMode.value = false;
    showAiContent.value = true;
    content.value = gptReply;

  } catch (err) {
    console.error('GPT API 錯誤:', err);
  }
}


// ----------------------
// 4. 顯示原文 / AI內容 切換
// ----------------------
// 監聽 viewMode 的改變，對應更新 showAiContent
watch(viewMode, (newVal) => {
  showAiContent.value = newVal
})

// 也可以反向：若你有其他地方改變 showAiContent，要同步更新 select
watch(showAiContent, (val) => {
  viewMode.value = val
})

// ----------------------
// 5. 儲存 (POST 到後端)
// ----------------------
async function saveHtml() {
  try {
    let contentToSave = ''
    // 假設你想根據「現在顯示哪個內容」來判斷要存哪個
    // (當 showAiContent = true 時，代表螢幕上顯示 AIHtml，
    //  否則顯示的是 myhtml)
    if (showAiContent.value) {
      // 使用者當下要存 AI 文章
      contentToSave = aiHtml.value
    } else {
      // 使用者要存原文
      contentToSave = myhtml.value
    }
    const res = await axios.post('/api/admin/savehtml', {
      edittype,
      product_id,
      htmlname,
      vpage,
      html: contentToSave
    })
    if (res.data.success) {
      Swal.fire({
        icon: 'success',
        title: '儲存成功',
        text: '已成功儲存內容'
      })
    } else {
      Swal.fire({
        icon: 'error',
        title: '儲存失敗',
        text: res.data.message
      })
    }
  } catch (err) {
    console.error('儲存錯誤:', err)
   Swal.fire({
      icon: 'error',
      title: '儲存錯誤',
      text: '請檢查網路連線或稍後再試'
    })
  }
}

</script>

<style scoped>
/* ---- 手機友善容器 ---- */
.page-container {
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 1rem;
  font-family: Arial, sans-serif;
}

/* 小螢幕再做一些調整 */
@media (max-width: 768px) {
  .page-container {
    width: 95%;
    padding: 1rem 0.5rem;
  }
}

.editor-section {
  margin-bottom: 1rem;
}

.current-status {
  font-size: 1rem;
  margin-bottom: 0.75rem;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

.preview-area {
  border: 1px solid #ccc;
  background: #fafafa;
  padding: 1rem;
}

/* 下拉 */
.my-select {
  min-width: 140px;
  padding: 6px 12px;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  outline: none;
  transition: border-color 0.2s ease;
}
.my-select:hover {
  border-color: #999;
}
.my-select:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.2);
}
.my-select:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.my-select-orange {
  color: #ff6600;
  font-weight: bold;
}

/* 按鈕 */
.my-btn {
  display: inline-block;
  padding: 8px 16px;
  background: #007bff;
  color: #fff;
  text-decoration: none;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  font-size: 1rem;
}
.my-btn:hover {
  background: #0056b3;
}
.my-btn-secondary {
  background: #6c757d;
}
.my-btn-secondary:hover {
  background: #5a6268;
}
.my-btn-danger {
  background: #dc3545;
}
.my-btn-danger:hover {
  background: #c82333;
}
.my-btn-orange {
  background: #ff6600;
}
.my-btn-orange:hover {
  background-color: #ff5500;
}

.my-btn:disabled,
.my-btn[disabled] {
  background-color: #ccc; /* 淺灰背景 */
  color: #999;            /* 灰字 */
  cursor: not-allowed;    /* 滑鼠變禁止符號 */
  opacity: 0.7;           /* 半透明 */
  /* 依需求加更多設計 */
}


/* 預覽內容 */
.detail-html,
.spec-html {
  margin-bottom: 2em;
  line-height: 1.6;
  color: #333;
  word-wrap: break-word; /* 舊屬性 */
  overflow-wrap: break-word; /* 新屬性 */
}

/* 讓內文中的媒體自適應 */
.detail-html img,
.detail-html iframe,
.detail-html video,
.spec-html img,
.spec-html iframe,
.spec-html video {
  max-width: 100%;
  height: auto;
  display: block;
}

/* Demo class for animations / images (可按需保留) */
.explore-products-btn {
  display: inline-block;
  margin-top: 20px;
  padding: 10px 20px;
  background-color: #ff6600;
  color: white;
  text-decoration: none;
  font-weight: bold;
  border-radius: 5px;
  transition: background-color 0.3s ease, transform 0.3s ease;
}
.explore-products-btn:hover {
  background-color: #b14801;
  transform: scale(1.05);
}

.content-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  align-items: center;
}
.text-section {
  flex: 1;
  min-width: 300px;
  padding-right: 20px;
  opacity: 0;
  transform: translateX(-50px);
  transition: opacity 0.8s ease, transform 0.8s ease;
}
.animated-text.visible {
  opacity: 1;
  transform: translateX(0);
}
.text-section h1 {
  font-size: 2.5rem;
  color: #333;
  margin-bottom: 10px;
}
.text-section h2 {
  font-size: 1.5rem;
  color: #800000;
  margin-top: 20px;
}
.text-section p {
  margin-bottom: 15px;
  line-height: 1.8;
  color: #555;
}
.text-section ul {
  list-style-type: disc;
  padding-left: 20px;
}
.text-section ul li {
  margin-bottom: 10px;
}
.image-section {
  flex: 1;
  min-width: 300px;
  text-align: center;
  opacity: 0;
  transform: scale(0.8);
  transition: opacity 0.8s ease, transform 0.8s ease;
}
.animated-image.visible {
  opacity: 1;
  transform: scale(1);
}
.about-image {
  width: 100%;
  max-width: 330px;
  transition: opacity 1s ease, transform 1s ease, box-shadow 0.5s ease;
  border-radius: 15px;
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1),
    0 4px 6px rgba(0, 0, 0, 0.06);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: 5px solid #fff;
}
.about-image:hover {
  transform: scale(1.05);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}
@media (max-width: 768px) {
  .content-wrapper {
    flex-direction: column;
  }
  .text-section {
    padding-right: 0;
  }
  .about-image {
    max-width: 300px;
  }
}
</style>